import Logo from "./Logo";
import { Link } from "react-router-dom";
import { Instagram, Phone, MapPin } from "lucide-react";

export default function PublicLayout({ children }) {
  return (
    <div className="min-h-screen gsx-gradient text-slate-100">
      <main>{children}</main>
      <footer className="border-t border-amber-500/10 mt-24 py-12 bg-[#040D1A]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <Logo size={48} />
            <p className="text-sm text-slate-400 mt-4 max-w-md leading-relaxed">
              Grupo Santo de Xadrez — desde 2013 formando campeões em Sergipe.
              Treinamento, evolução e competição em alto nível.
            </p>
          </div>
          <div>
            <h4 className="text-white font-semibold text-sm mb-4">Contato</h4>
            <ul className="space-y-3 text-sm text-slate-300">
              <li className="flex items-center gap-2">
                <Phone className="w-4 h-4 text-amber-400" />
                <a href="tel:+5579998852357" data-testid="footer-phone" className="hover:text-amber-300">(79) 99885-2357</a>
              </li>
              <li className="flex items-center gap-2">
                <Instagram className="w-4 h-4 text-amber-400" />
                <a href="https://instagram.com/gruposantodexadrez" target="_blank" rel="noreferrer"
                  data-testid="footer-instagram" className="hover:text-amber-300">@gruposantodexadrez</a>
              </li>
              <li className="flex items-center gap-2">
                <MapPin className="w-4 h-4 text-amber-400" />
                <span>Aracaju — Sergipe</span>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold text-sm mb-4">Institucional</h4>
            <ul className="space-y-2 text-sm text-slate-300">
              <li><Link to="/torneios" className="hover:text-amber-300">Torneios</Link></li>
              <li><Link to="/aula-experimental" className="hover:text-amber-300">Aula Experimental</Link></li>
              <li><Link to="/login" className="hover:text-amber-300">Área do Atleta</Link></li>
            </ul>
          </div>
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-10 pt-6 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-500 tracking-wide">© 2026 Grupo Santo de Xadrez — Todos os direitos reservados.</p>
          <p className="text-xs text-amber-400/80 tracking-wide">Treinamento, evolução e competição.</p>
        </div>
      </footer>
    </div>
  );
}
